import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { investmentDurationOptions2 } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'crowdfunding-project-duration',
    templateUrl: './crowdfunding-project-duration.component.html',
    styleUrls: ['./crowdfunding-project-duration.component.scss'],
    standalone: false
})
export class CrowdfundingProjectDurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  crowdfundingProjectDurationOptions = investmentDurationOptions2;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
